import React from 'react';
import { createRoot } from 'react-dom/client';
import FeedbackForm from './Components/FeedbackForm/FeedbackForm';
import App from './App';

const dashboardMountPoint = document.getElementById('post-feedback-dashboard');
if (dashboardMountPoint) {
  createRoot(dashboardMountPoint).render(<App page="dashboard" />);
}

const feedbackFormMountPoint = document.getElementById('post-feedback-form');
if (feedbackFormMountPoint) {
  createRoot(feedbackFormMountPoint).render(<FeedbackForm />);
}